import {addBaseQueryParams, addQueryParams, BaseQueryParams} from "@commons/utils/APIParams";
import {config} from "@commons/config.instance";
import axios from "axios";
import {CausaleWFRecord} from "@commons/mapping/CausaleWFRecord";
import {TabellaWFRecord} from "@commons/mapping/TabellaWFRecord";

export interface DominioParams extends BaseQueryParams {
    idDominio: number,
}

export interface TabellaDominioParams extends DominioParams {
    idTabella: number,
}

export interface CausaliWFParams extends TabellaDominioParams {
    idAziendaTabelle: number
}

export const listImpiantiWF = (params: Partial<DominioParams>) => {
    const queryParams: string[] = addBaseQueryParams(params);
    const finalUrl = config.getBaseUrl('FPNet') + `/domain/${params.idDominio}/tabella-wf?${addQueryParams(queryParams)}`;
    return axios<TabellaWFRecord[]>(finalUrl).then(res => {
        //return res.data;
        // @ts-ignore
        return Object.keys(res.data).map(i => res.data[i]) as TabellaWFRecord[]; // !!!!!! todo DA CAPIRE !!!!!!
    })
}
export const getImpiantoWF = (params: Partial<TabellaDominioParams>) => {
    const queryParams: string[] = addBaseQueryParams(params);
    const finalUrl = config.getBaseUrl('FPNet') + `/domain/${params.idDominio}/tabella-wf/${params.idTabella}?${addQueryParams(queryParams)}`;
    return axios<TabellaWFRecord>(finalUrl).then(res => {
        return res.data;
    })
}

export const listCausaliWF = (params: Partial<CausaliWFParams>) => {
    // console.log('listCausaliWF console params ',params)
    // console.log('console params ID az tabelle ',params.idAziendaTabelle)

    const queryParams: string[] = addBaseQueryParams(params);
    if (params.idAziendaTabelle)
        queryParams.push(`idAziendaTabelle=${params.idAziendaTabelle}`);
    const finalUrl = config.getBaseUrl('FPNet') + `/domain/${params.idDominio}/tabella-wf/${params.idTabella}/aggancio/causale?${addQueryParams(queryParams)}`;

    return axios<CausaleWFRecord[]>(finalUrl).then(res => {
        //return res.data;
        // @ts-ignore
        return Object.keys(res.data).map(i => res.data[i]) as CausaleWFRecord[]; // !!!!!! todo DA CAPIRE !!!!!!
    })
}
